import { UtilityFunctions } from 'app/shared/utilities/functions.models';
import { GridSchema } from '../common/grid-schema.model';
import { BadgeColorEnum } from '../../enum/badge-color.enum.model';
import { VoucherStatusEnum } from 'app/shared/enums/voucher-status.enum';


export interface GridVouchersSchema<T> extends GridSchema<T> {
  voucherSelected?: T;
  status?: VoucherStatusEnum;
};

export class VoucherDto {
  id: number;
  externalId?: string;
  code: string;
  description: string;
  validityDateFrom: string;
  validityDateTo: string;
  amount: number;
  threshold: number;
  storeId: number;
  constraintType: ConstraintTypeEnum;
  residualAmount?: number;
  applicableAsPartialPayment: boolean;
  creationTime?: string;
  creatorId?: number;
  lastModificationTime?: string;
  lastModifierId?: number;
  isArchived?: boolean;
  constructor(init?: VoucherDto) {
    Object.assign(this, init);
    if (!this.amount) this.amount = null;
    if (!this.code) this.code = null;
    if (!this.description) this.description = null;
    if (!this.threshold) this.threshold = null;
    if (!this.validityDateFrom) this.validityDateFrom = null;
    if (!this.validityDateTo) this.validityDateTo = null;
  }
}

export class OrderVoucherDto {
  voucher: VoucherDto;
  usedAmount: number;

  constructor(init?: OrderVoucherDto) {
    Object.assign(this, init);
  }
}

export class VoucherPrivilageCashDto {
  externalId: string;
  name: string;
  amount: number;
  residualAmountWithVAT: number;
  residualAmountWithoutVAT: number;
  validFrom: string;
  validUntil: string;
  associatedVoucherId: number;
  availableForNewVoucher: boolean;
  constructor(init?: VoucherPrivilageCashDto) {
    Object.assign(this, init);
  }
}
export class VoucherPrivilageCashVM extends VoucherPrivilageCashDto {
  checked: boolean;
  isDisabled: boolean;
  constructor(init?: VoucherPrivilageCashVM) {
    super(init);
    Object.assign(this, init);
  }
}

export class VoucherVM extends VoucherDto {
  textToView?: string;
  checked?: boolean;
  constructor(init?: VoucherVM) {
    super(init);
    this.textToView = this.code + ' - ' + this.description;
  }
};

export class VoucherVMConfirmCartModel {
  voucherId: number;
  name: string;
  code: string;
  description: string;
  amount: number;
  residual: string;
  residualAmount: number;
  customerBadge: BadgeColorEnum;
  constructor(init?: VoucherVMConfirmCartModel) {
    Object.assign(this, init);
  }

};

export enum ConstraintTypeEnum {
  Unconstrained = 1,
  ByOrderTotalAmount = 2,
  ByOrderTotalQuantity = 3
}
